// news inner
const headerHeight = $('#header').height();
const $postSidemenu = $('.js-post-sidemenu');
const $postWrap = $('.post-inner .custom-editor');
const $post_h2_list = $postWrap.find('h2:not(".related-title")');
let post_h2_data = []; // h2 區塊的資訊
function updatePostH2Data() {
  post_h2_data = [];
  $post_h2_list.each(function (index, h2) {
    $(h2).attr('id', `h2-${index}`);
    post_h2_data.push({
      id: `h2-${index}`,
      offsetTop: $(h2).offset().top - 30
    })
  });
}
if ($post_h2_list.length != 0) {
  // set h2
  updatePostH2Data();
  // set sidemenu
  $postSidemenu.each(function (i, sidemenu) {
    let $postSidemenuContent = $(sidemenu).find('.post-sidemenu-content'); // 內容容器
    $postSidemenuContent.append('<ul></ul>');
    // set link anchor
    $post_h2_list.each(function (index, el) {
      $postSidemenuContent.find('ul').append(`<li class="sidemenu-item" data-id="h2-${index}"><a href="#h2-${index}">${$(el).text()}</a></li>`);
      $postSidemenuContent.find(`[href="#h2-${index}"]`).on('click', function () {
        $("html,body").animate({ scrollTop: $(el).offset().top - 10 - headerHeight }, 500);
      });
    });
  })
}
$(window).on('scroll', function () {
  // 如果頁面上有 postSidemenu
  if ($postSidemenu.length != 0) {
    let scrolled = $(window).scrollTop();
    $('.sidemenu-item').removeClass('active');
    // 判斷目前在哪個 h2 標籤下
    for (const d of post_h2_data) {
      if (scrolled >= d.offsetTop) {
        $('.sidemenu-item').removeClass('active');
        $(`[data-id="${d.id}"]`).addClass('active');
      }
    }
  }
});
let sidemenuResizeTimer; // resize計時器
$(window).on('resize', function () {
  clearTimeout(sidemenuResizeTimer);
  sidemenuResizeTimer = setTimeout(function () {
    // 如果頁面上有 postSidemenu
    if ($postSidemenu.length != 0) {
      updatePostH2Data()
    }
  }, 200);
});
